import $ from "jquery";

const floatingButton = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    $(function () {
      const el = {
        buttonCheckout:
          ".CheckoutPage .js-box_review_order .wrapper-button, .CheckoutPage .js-box_review_order button#place_order",
        stopPointCheckout:
          ".CheckoutPage .js-box_review_order .form-row.place-order",
      };

      const windowWidth = $(window).width();

      if (windowWidth > 600) return;
      if ($(el.buttonCheckout).length === 0) return;

      $.fn.isInViewport = function () {
        let elementTop = $(this).offset().top;

        let viewportTop = $(window).scrollTop();

        let viewportHalf = viewportTop + $(window).height();

        return elementTop < viewportHalf;
      };

      $(window).on("load resize scroll", function () {
        if ($(el.stopPointCheckout).isInViewport()) {
          $(el.buttonCheckout).addClass("offset");
        } else {
          $(el.buttonCheckout).removeClass("offset");
        }
      });
    });
  };

  init();
};

try {
  floatingButton();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error("floatingButton :" + error);
}
